import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/portal/discussion", label: "Group chat", icon: ChatIcon, end: false },
  { to: "/portal/events", label: "Events", icon: CalendarIcon, end: false },
  { to: "/portal", label: "Reading", icon: BookIcon, end: true },
  { to: "/portal/members", label: "Members", icon: PeopleIcon, end: false },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav" aria-label="Portal sections">
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `bottom-nav__tab${isActive ? " is-active" : ""}`
            }
          >
            <Icon />
            <span>{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

const iconBase = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path
        {...iconBase}
        d="M21 11.5c0 4.7-4.03 8.5-9 8.5-1.46 0-2.84-.33-4.06-.92L3 20l1.04-3.95C3.38 14.92 3 13.25 3 11.5 3 6.8 7.03 3 12 3s9 3.8 9 8.5z"
      />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <rect {...iconBase} x="3" y="5" width="18" height="16" rx="2" />
      <path {...iconBase} d="M3 10h18M8 3v4M16 3v4" />
    </svg>
  );
}

function BookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path
        {...iconBase}
        d="M3 5c2.5-1 5.5-1 9 0v15c-3.5-1-6.5-1-9 0V5zM12 5c3.5-1 6.5-1 9 0v15c-2.5-1-5.5-1-9 0"
      />
    </svg>
  );
}

function PeopleIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <circle {...iconBase} cx="9" cy="8" r="3.2" />
      <circle {...iconBase} cx="17" cy="9.5" r="2.4" />
      <path
        {...iconBase}
        d="M3 19c0-3 2.7-5 6-5s6 2 6 5M15 19c0-2 1.5-3.5 4-3.5s2 0 2 3.5"
      />
    </svg>
  );
}
